export default __webpack_public_path__ + "static/joko-app-screenshot-home-5-fr@2x-9834770700a7bc705234c5ff972bdadf.png";